/**
 * Helper para acceder al usuario actual desde el JWT en localStorage.
 *
 * El backend del proyecto pone los claims útiles directamente en el
 * payload del token (id, rol, nombre, apellidos, mail_empresa, etc.).
 * Para evitar dependencias circulares o hacer una llamada extra, los
 * leemos directamente decodificando el JWT.
 *
 * NOTA DE SEGURIDAD: este decode NO verifica la firma del token.
 * Solo lo usamos para decisiones de UI (mostrar/ocultar items del
 * sidebar según rol). Cualquier operación sensible va validada en
 * el backend con authMiddleware + checkPermiso.
 */

export function getCurrentUser() {
  const token = localStorage.getItem('token');
  if (!token) return null;
  try {
    const [, payloadB64] = token.split('.');
    if (!payloadB64) return null;
    const payload = JSON.parse(atob(payloadB64));
    return payload;
  } catch {
    return null;
  }
}

export function isSuperAdmin() {
  const user = getCurrentUser();
  return user?.rol === 'Super Administrador';
}
